"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSemanticUiRange = require("react-semantic-ui-range");

var _semanticUiReact = require("semantic-ui-react");

var _reactColorscales = require("react-colorscales");

var _reactWeathericons = require("react-weathericons");

var _reactWeathericons2 = _interopRequireDefault(_reactWeathericons);

var _ColorscalePicker = require("../../colorscalepicker/ColorscalePicker");

var _ColorscalePicker2 = _interopRequireDefault(_ColorscalePicker);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _MapVisualization = require("./MapVisualization.css");

var _MapVisualization2 = _interopRequireDefault(_MapVisualization);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //     


var MapVisualization = function (_Component) {
	_inherits(MapVisualization, _Component);

	function MapVisualization() {
		_classCallCheck(this, MapVisualization);

		var _this = _possibleConstructorReturn(this, (MapVisualization.__proto__ || Object.getPrototypeOf(MapVisualization)).call(this));

		_this.factorExtrussionChanged = function (factorZ) {
			var newLayers = [].concat(_toConsumableArray(_this.props.dataVisualitzacio.layers));
			newLayers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].extrussion = factorZ;
			_this.props.onChange(_extends({}, _this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		};

		_this.factorTextSizeChanged = function (factorT) {
			var newLayers = [].concat(_toConsumableArray(_this.props.dataVisualitzacio.layers));
			newLayers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontsize = factorT;
			_this.props.onChange(_extends({}, _this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		};

		_this.factorFontNameChanged = function (e, _ref) {
			var value = _ref.value;

			var newLayers = [].concat(_toConsumableArray(_this.props.dataVisualitzacio.layers));
			newLayers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontname = value;
			_this.props.onChange(_extends({}, _this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		};

		_this.onColorsValuesChange = function (colorsrangs) {
			var objectColor = {};
			if (!colorsrangs.colorscale) {
				objectColor.colorscale = colorsrangs;
				objectColor.label = false;
				objectColor.colorscaleType = "rangs";
			} else {
				objectColor = colorsrangs;
			}
			_this.setState({ colorscale: objectColor.colorscale });
			var newDataViz = _extends({}, _this.props.dataVisualitzacio, {
				colorrangs: objectColor
			});
			_this.props.onChange(newDataViz);
		};

		_this.onCloseMe = function () {
			_this.setState({ showColorscalePicker: false });
		};

		_this.toggleColorscalePicker = function () {
			_this.setState({ showColorscalePicker: !_this.state.showColorscalePicker });
			//this.setState({showColorscalePicker: true});
		};

		_this.state = {
			showColorscalePicker: false,
			colorscale: CONSTANTS.DEFAULT_SCALE
		};
		return _this;
	}

	_createClass(MapVisualization, [{
		key: "visualitazioTitleChange",
		value: function visualitazioTitleChange(visualitazioTitle) {
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				title: visualitazioTitle
			}));
		}
	}, {
		key: "fieldChanged",
		value: function fieldChanged(fieldName) {
			if (fieldName === 'alt') {
				this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
					fieldvalue: "_value",
					field: fieldName
				}));
			} else {
				this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
					field: fieldName
				}));
			}
		}
	}, {
		key: "fieldValuesChanged",
		value: function fieldValuesChanged(fieldvalue) {
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				fieldvalue: fieldvalue
			}));
		}
	}, {
		key: "viewViz",
		value: function viewViz() {
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				isVisible: !this.props.dataVisualitzacio.isVisible
			}));
		}
	}, {
		key: "handleOpChange",
		value: function handleOpChange(op) {
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				op: op
			}));
		}
	}, {
		key: "onclickIconsWheather",
		value: function onclickIconsWheather(nameWeatherIcon, styleWeatherIcon) {
			var newDataViz = _extends({}, this.props.dataVisualitzacio, {
				visualization: _extends({}, this.props.dataVisualitzacio.visualization, {
					weathericon: nameWeatherIcon,
					weathercoloricon: styleWeatherIcon
				})
			});
			this.props.onChange(newDataViz);
		}
	}, {
		key: "renderPopupWeatherIconsGrid",
		value: function renderPopupWeatherIconsGrid() {
			var _this2 = this;

			var grid = [];
			var id = 0;
			CONSTANTS.WEATHER_ICONS_TYPES.forEach(function (weatherType, index) {
				var newRow = [];
				CONSTANTS.WEATHER_ICONS_STYLES.forEach(function (weatherStyle) {
					var style = _MapVisualization2.default[weatherStyle];
					newRow.push(_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						{ key: id, textAlign: "center" },
						_react2.default.createElement(_reactWeathericons2.default, { onClick: function onClick() {
								return _this2.onclickIconsWheather(weatherType, weatherStyle);
							}, name: weatherType, className: style, size: "2x" })
					));
					id++;
				});
				grid.push(_react2.default.createElement(
					_semanticUiReact.Grid.Row,
					{ key: index, className: _MapVisualization2.default.row2 },
					newRow
				));
			});
			return grid;
		}
	}, {
		key: "renderPopupWeatherIcons",
		value: function renderPopupWeatherIcons() {
			var visualization = this.props.dataVisualitzacio.visualization;

			var currentClassName = _MapVisualization2.default[visualization.weathercoloricon];
			return _react2.default.createElement(
				_semanticUiReact.Popup,
				{
					position: "bottom left",
					size: "mini",
					trigger: _react2.default.createElement(
						"span",
						{ className: _MapVisualization2.default.spanIcon },
						_react2.default.createElement(
							"span",
							null,
							_react2.default.createElement(_reactWeathericons2.default, { name: visualization.weathericon, className: currentClassName }),
							"\xA0",
							_react2.default.createElement("i", { className: "dropdown icon" })
						)
					),
					flowing: true,
					hoverable: true },
				_react2.default.createElement(
					_semanticUiReact.Grid,
					{ className: _MapVisualization2.default.popup, centered: true, celled: true, columns: 3 },
					this.renderPopupWeatherIconsGrid()
				)
			);
		}
	}, {
		key: "renderSelectCamp",
		value: function renderSelectCamp() {
			var _this3 = this;

			var fieldsList = [];
			this.props.fieldsToVisualize.map(function (item, index) {
				fieldsList.push({
					key: index,
					text: item,
					value: item
				});
			});
			// console.log('props', this.props)
			return _react2.default.createElement(
				_semanticUiReact.Label,
				{ className: _MapVisualization2.default.myLabelDropdown },
				"Camps:",
				_react2.default.createElement(_semanticUiReact.Dropdown, {
					className: _MapVisualization2.default.myDropdown,
					key: "dropLabel",
					search: true, selection: true, fluid: true,
					color: "teal",
					value: this.props.dataVisualitzacio.field,
					options: fieldsList,
					onChange: function onChange(e, data) {
						return _this3.fieldChanged(data.value);
					} })
			);
		}
	}, {
		key: "renderSelectValor",
		value: function renderSelectValor() {
			var _this4 = this;

			if (this.props.dataVisualitzacio.field !== 'alt') {
				return _react2.default.createElement(
					_semanticUiReact.Label,
					{ className: _MapVisualization2.default.myLabelDropdown },
					"Valors:",
					_react2.default.createElement(_semanticUiReact.Dropdown, {
						className: _MapVisualization2.default.myDropdown,
						search: true, selection: true, fluid: true,
						onChange: function onChange(e, data) {
							return _this4.fieldValuesChanged(data.value);
						},
						value: this.props.dataVisualitzacio.fieldvalue,
						options: this.props.fieldsCalcValues
					})
				);
			}
		}
	}, {
		key: "renderColorScalePicker",
		value: function renderColorScalePicker() {
			var toggleButtonStyle = this.state.showColorscalePicker ? { borderColor: "#A2B1C6" } : {};
			var orga = this.props.organization;
			//const FILE_COLOR = orga === CONSTANTS.ORGA_TV3 ? CONSTANTS.COLORS_FILENAME_TV3 : CONSTANTS.COLORS_FILENAME_SMC;
			var FILE_COLOR = CONSTANTS.COLORS_FILENAME_TV3;
			if (orga === CONSTANTS.ORGA_SMC) {
				FILE_COLOR = CONSTANTS.COLORS_FILENAME_SMC;
			}
			if (orga === CONSTANTS.ORGA_ICGC) {
				FILE_COLOR = CONSTANTS.COLORS_FILENAME_ICGC;
			}
			var colorScale = this.props.dataVisualitzacio.colorrangs.colorscale ? this.props.dataVisualitzacio.colorrangs.colorscale : this.props.dataVisualitzacio.colorrangs;
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					"div",
					{ onClick: this.toggleColorscalePicker, className: _MapVisualization2.default.toggleButton, style: toggleButtonStyle },
					"Rang de colors:",
					_react2.default.createElement(_reactColorscales.Colorscale, {
						colorscale: colorScale,
						onClick: function onClick() {},
						width: 200
					})
				),
				this.state.showColorscalePicker && _react2.default.createElement(_ColorscalePicker2.default, {
					onChange: this.onColorsValuesChange,
					onCloseMe: this.onCloseMe.bind(this),
					colorscale: colorScale,
					nSwatches: colorScale.length,
					className: _MapVisualization2.default.colorscalePickerContainer,
					urlGetColors: CONSTANTS.URL_GET_FILE_CONTENT,
					urlSetColors: CONSTANTS.URL_SET_FILE_CONTENT,
					filename: FILE_COLOR
				})
			);
		}
		/*
  renderColorScalePickerPopup() {
  	if (this.state.showColorscalePicker) {
  		return <ColorscalePicker
  			onChange={this.onColorsValuesChange}
  			colorscale={this.state.colorscale}
  			nSwatches={this.state.colorscale.length}
  			className={styles.colorscalePickerContainer}
  		/>;
  	}
  }
  */

	}, {
		key: "onDisplayLayerChange2",
		value: function onDisplayLayerChange2(layerGeom, layerStatus) {
			var newLayers = this.props.dataVisualitzacio.layers;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = newLayers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var layer = _step.value;

					if (layer.name === layerGeom) {
						layer.visibility = layerStatus;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		}
	}, {
		key: "onDisplayLayerChangeBadge",
		value: function onDisplayLayerChangeBadge(indexLayer, layerStatus) {
			var newLayers = this.props.dataVisualitzacio.layers;
			newLayers[indexLayer].badge = layerStatus;
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		}
	}, {
		key: "onDisplayLayerChange",
		value: function onDisplayLayerChange(indexLayer, layerStatus) {
			var newLayers = this.props.dataVisualitzacio.layers;
			newLayers[indexLayer].visibility = layerStatus;
			this.props.onChange(_extends({}, this.props.dataVisualitzacio, {
				layers: newLayers
			}));
		}
	}, {
		key: "renderExtrussionItem",
		value: function renderExtrussionItem() {
			var _this5 = this;

			var startVal = this.props.dataVisualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_POL].extrussion;
			return _react2.default.createElement(
				_semanticUiReact.Grid.Row,
				{ className: _MapVisualization2.default.myBox },
				_react2.default.createElement(
					_semanticUiReact.Grid.Column,
					{ width: 8 },
					_react2.default.createElement(_semanticUiReact.Checkbox, {
						size: "mini",
						id: "visualization" + this.props.id + CONSTANTS.DEFAULT_INDEX_SUFFIX_POL,
						onChange: function onChange(_e, data) {
							return _this5.onDisplayLayerChange(CONSTANTS.DEFAULT_INDEX_LAYER_POL, data.checked);
						},
						label: "Geometria",
						color: "blue",
						className: _MapVisualization2.default.checkStyle,
						defaultChecked: true,
						toggle: true
					})
				),
				_react2.default.createElement(
					_semanticUiReact.Grid.Column,
					{ className: _MapVisualization2.default.textAlignCenter, width: 8 },
					_react2.default.createElement(_reactSemanticUiRange.Slider, { color: "teal",
						settings: {
							start: startVal,
							min: 0,
							max: 1000,
							step: 100,
							onChange: this.factorExtrussionChanged
						} }),
					_react2.default.createElement(
						"span",
						{ className: _MapVisualization2.default.listMin, color: "red" },
						"Extrussi\xF3: " + this.props.dataVisualitzacio.layers[0].extrussion
					)
				)
			);
		}
	}, {
		key: "renderFontItem",
		value: function renderFontItem() {
			var _this6 = this;

			var startVal = this.props.dataVisualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontsize;
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_semanticUiReact.Grid.Row,
					{ className: _MapVisualization2.default.myBox },
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						{ width: 8 },
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							size: "mini",
							id: "visualization" + this.props.id + CONSTANTS.DEFAULT_INDEX_SUFFIX_TEXT,
							onChange: function onChange(_e, data) {
								return _this6.onDisplayLayerChange(CONSTANTS.DEFAULT_INDEX_LAYER_TEXT, data.checked);
							},
							label: "Text", className: _MapVisualization2.default.checkStyle, defaultChecked: true, toggle: true })
					),
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						{ className: _MapVisualization2.default.textAlignCenter, width: 8 },
						_react2.default.createElement(_reactSemanticUiRange.Slider, { color: "blue", inverted: false,
							settings: {
								start: startVal,
								min: 1,
								max: 20,
								step: 1,
								onChange: this.factorTextSizeChanged
							} }),
						_react2.default.createElement(
							"span",
							{ className: _MapVisualization2.default.listMin, color: "red" },
							"Font: " + this.props.dataVisualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontsize
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						{ width: 16 },
						_react2.default.createElement(_semanticUiReact.Checkbox, {
							size: "mini",
							id: "avisualization" + this.props.id + CONSTANTS.DEFAULT_INDEX_SUFFIX_TEXT,
							onChange: function onChange(_e, data) {
								return _this6.onDisplayLayerChangeBadge(CONSTANTS.DEFAULT_INDEX_LAYER_TEXT, data.checked);
							},
							checked: this.props.dataVisualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].badge || false,
							label: "Max/Min", className: _MapVisualization2.default.checkStyle, toggle: true }),
						_react2.default.createElement(_semanticUiReact.Popup, {
							size: "mini",
							className: _MapVisualization2.default.myPopUp,
							position: "right center",
							trigger: _react2.default.createElement(_semanticUiReact.Icon, { className: _MapVisualization2.default.iconPopup, size: "small", circular: true, fitted: true, color: "blue", name: "question" }),
							content: "Resalta m\xE0xims i m\xEDnims" })
					),
					_react2.default.createElement(
						_semanticUiReact.Grid.Column,
						{ width: 16 },
						_react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
						_react2.default.createElement(_semanticUiReact.Dropdown, {
							fluid: true,
							labeled: true,
							button: true,
							className: "icon",
							floating: true,
							icon: "font",
							onChange: this.factorFontNameChanged,
							options: CONSTANTS.SELECT_TIPUS_FONT,
							selection: true,
							value: this.props.dataVisualitzacio.layers[CONSTANTS.DEFAULT_INDEX_LAYER_TEXT].fontname
						})
					)
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this7 = this;

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				{ padded: true, color: "teal" },
				_react2.default.createElement(
					_semanticUiReact.Grid,
					{ verticalAlign: "middle" },
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(
							_semanticUiReact.Input,
							{
								labelPosition: "right",
								size: "mini",
								onChange: function onChange(_e, data) {
									return _this7.visualitazioTitleChange(data.value);
								},
								value: this.props.dataVisualitzacio.title },
							_react2.default.createElement(
								_semanticUiReact.Label,
								{ horizontal: true, className: _MapVisualization2.default.myLabel },
								"Nom"
							),
							_react2.default.createElement("input", null),
							_react2.default.createElement(
								_semanticUiReact.Label,
								{ basic: true },
								this.renderPopupWeatherIcons()
							)
						)
					),
					_react2.default.createElement(_semanticUiReact.Header, { size: "small", content: "Dades:", dividing: true, className: _MapVisualization2.default.myHeaderVis }),
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 16 },
							this.renderSelectCamp()
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 16 },
							this.renderSelectValor()
						)
					),
					_react2.default.createElement(_semanticUiReact.Header, { size: "small", content: "Estilitzaci\xF3:", dividing: true, className: _MapVisualization2.default.myHeaderVis }),
					_react2.default.createElement(
						_semanticUiReact.Grid.Row,
						null,
						_react2.default.createElement(
							_semanticUiReact.Grid.Column,
							{ width: 16, className: _MapVisualization2.default.paddingZero },
							this.renderColorScalePicker()
						)
					),
					this.renderExtrussionItem(),
					this.renderFontItem()
				)
			);
		}
	}]);

	return MapVisualization;
}(_react.Component);

exports.default = MapVisualization;

MapVisualization.propTypes = {
	dataVisualitzacio: _propTypes2.default.object,
	id: _propTypes2.default.number,
	organization: _propTypes2.default.string,
	fieldsToVisualize: _propTypes2.default.array,
	fieldsCalcValues: _propTypes2.default.array,
	onChange: _propTypes2.default.func
};
